import React from "react"
import { Stack, Typography } from "@mui/material"
import { PE_STATUSES_AND_LABELS } from "../../../utils/packagingExecutions"
import {
	PEPSEResumeLabel,
	PEPSEMultiplePackagingInfo,
	PEPSEResumeInfo,
	PEPSEResumeContainer
} from "../../ProductionStepExecutions/preview/StyledExecutionPreviewComponents"
import { capitalizeFirstLetter } from "../../../utils"
import ExecutionsStatus from "../../ProductionStepExecutions/ExecutionsStatus"

const getPackagingNumber = (packagingNumbers) => {
	const foodcheriPackaging = packagingNumbers.find(item => item.brand === "FOODCHERI")
	const value = foodcheriPackaging ? foodcheriPackaging.value : "1"
	return +value
}

const PackagingExecutionResume = ({
	recipeLabel,
	status,
	fitCornerTag,
	packagingLine = "_",
	expectedPackagingNumber = 0,
	uniqueCode,
	packagingNumbers = [],
	hasSubStatus = null
}) => {
	return (
		<PEPSEResumeContainer isFitCornerTag={!!fitCornerTag}>
			<Stack spacing={2}>
				<Stack direction="row" alignItems="center" spacing={2}>
					{hasSubStatus && 
						<ExecutionsStatus
							statusValue="INSUFFICIENT_WEIGHT"
							statusName="Quantité insuffisante" />
					}
					<Typography variant="h6">
						{uniqueCode} - {recipeLabel}
					</Typography>
					<ExecutionsStatus
						statusValue={status}
						statusName={PE_STATUSES_AND_LABELS.find(item => item.key === status)?.label}
					/>
				</Stack>
				<Stack spacing={3} direction="row">
					<Stack spacing={1}>
						<PEPSEResumeLabel>
							Ligne de barquettage
						</PEPSEResumeLabel>
						<PEPSEResumeInfo>
							{capitalizeFirstLetter(packagingLine)}
						</PEPSEResumeInfo>
					</Stack>
					<Stack spacing={1}>
						<PEPSEResumeLabel>
							Nb théorique de produits
						</PEPSEResumeLabel>
						<PEPSEResumeInfo>
							{Math.round(expectedPackagingNumber * 100) / 100}
						</PEPSEResumeInfo>
					</Stack>
					{getPackagingNumber(packagingNumbers) > 1 && 
						<Stack spacing={1}>
							<PEPSEResumeLabel>
								Nb de produits par barquette
							</PEPSEResumeLabel>
							<PEPSEMultiplePackagingInfo>
								{getPackagingNumber(packagingNumbers)} par barquette
							</PEPSEMultiplePackagingInfo>
						</Stack>
					}
					{!!fitCornerTag && (
						<Stack spacing={4 / 6}>
							<PEPSEResumeLabel>
								Gamme
							</PEPSEResumeLabel>
							<Stack direction="row" alignItems="center" spacing={1}>
									<img alt="fit-corner-tag" src="/icons/heart-fitcorner.svg" />
									<PEPSEResumeInfo>
										{fitCornerTag.name}
									</PEPSEResumeInfo>
							</Stack>
						</Stack>
					)}
				</Stack>
			</Stack>
		</PEPSEResumeContainer>
	)
}

export default PackagingExecutionResume